import {
  ICarrierAssigned,
  IAssignShipmentToDriverInputProps,
  IAssignShipmentToDriverV2InputProps,
  IAssignDriverStartLocationV2InputProps
} from '../../schemas/carrierAssign/CarrierAssign.schema';
import { setObject, getObject } from '../../utils/common';
import { stopActivityProps } from '../stopActivity.model';

export class CarrierLoads {
  private readonly carrierLoadsState: ICarrierAssigned = {};
  get carrierId() {
    return this.carrierLoadsState.carrierId;
  }

  set carrierId(value) {
    if (value) {
      this.carrierLoadsState.carrierId = value;
    }
  }

  assignShipmentToDriver(data: IAssignShipmentToDriverInputProps) {
    return {
      mutation: {
        assignDriverToShipment: {
          __args: {
            input: data
          },
          status: true,
          message: true,
          shipment: {
            shipmentId: true,
            transportMode: true,
            totalWeight: true,
            weightUOM: true,
            totalDistance: true,
            distanceUOM: true,
            numberOfStops: true,
            sourceTMS: true,
            shipmentTenderedCarriers : {
              recordId : true,
              shipmentId : true,
              carrierId : true,
              offeredRate : true
            },
            division: true,
            assignedCarrierId: true,
            assignedTMSCarrierId: true,
            isHazardous: true,
            isHighValue: true,
            isTemperatureControlled: true,
            readyDateTime: true,
            readyDateTimeZone: true,
            equipmentType: true,
            predecessorShipmentId: true,
            successorShipmentId: true,
            assignmentStatus: true,
            executionStatus: true,
            driverAssignmentStatus: true,
            shipmentServices: {
              serviceDescription: true
            },
            startState: true,
            startCity: true,
            startDateTime: true,
            loadStop: {
              stopId: true,
              locationId: true,
              stopType: true,
              sequenceNo: true,
              locationName: true,
              addressLine1: true,
              addressLine2: true,
              city: true,
              state: true,
              country: true,
              postalCode: true,
              timeZone: true,
              longitude: true,
              latitude: true,
              estimatedArrivalDateTime: true,
              plannedArrivalDateTime: true,
              actualArrivalDateTime: true,
              estimatedStopDuration: true,
              plannedDepartureDateTime: true,
              actualDepartureDateTime: true,
              appointmentEarlyDateTime: true,
              appointmentState:true,
              appointmentLateDateTime: true,
              estimatedStopDurationUom: true,
              plannedEtaDateTime: true,
              stopActivity: stopActivityProps,
              stopReference: {
                id: true,
                type: true,
                value: true,
                stopId: true,
                shipmentId: true
              }
            },
            shipmentInvolvedParties: {
              id: true,
              partyId: true,
              partyType: true,
              partyName: true,
              partyEmail: true,
              partyPhone: true
            },
            assignmentTransaction: {
              transactionId: true,
              shipmentId: true,
              transactionType: true,
              driverId: true,
              driverPhone: true,
              driverEmail: true,
              status: true,
              driverName: true
            },
            managedEquipment: true,
            automatedTrackingInProgress: true,
          }
        }
      }
    };
  }

  assignShipmentToDriverV2(assignData: IAssignShipmentToDriverV2InputProps, startLocationData?: IAssignDriverStartLocationV2InputProps | null) {
    return {
      mutation: {
        assignDriverV2: {
          __args: {
            input: {
              assignDriver: assignData,
              assignSource: "",
              startLocation: startLocationData
            }
          },
          status: true,
          message: true,
          shipment: {
            shipmentId: true,
            carrierPro: true,
            shipmentState: true,
            transportMode: true,
            totalWeight: true,
            weightUOM: true,
            totalDistance: true,
            distanceUOM: true,
            numberOfStops: true,
            sourceTMS: true,
            shipmentTenderedCarriers : {
              recordId : true,
              shipmentId : true,
              carrierId : true,
              offeredRate : true
            },
            division: true,
            assignedCarrierId: true,
            assignedTMSCarrierId: true,
            isHazardous: true,
            isHighValue: true,
            isTemperatureControlled: true,
            readyDateTime: true,
            readyDateTimeZone: true,
            equipmentType: true,
            predecessorShipmentId: true,
            successorShipmentId: true,
            assignmentStatus: true,
            executionStatus: true,
            driverAssignmentStatus: true,
            shipmentServices: {
              serviceDescription: true
            },
            startState: true,
            startCity: true,
            startDateTime: true,
            loadStop: {
              stopId: true,
              locationId: true,
              stopType: true,
              sequenceNo: true,
              locationName: true,
              addressLine1: true,
              addressLine2: true,
              city: true,
              state: true,
              country: true,
              postalCode: true,
              timeZone: true,
              longitude: true,
              latitude: true,
              estimatedArrivalDateTime: true,
              plannedArrivalDateTime: true,
              actualArrivalDateTime: true,
              estimatedStopDuration: true,
              plannedDepartureDateTime: true,
              actualDepartureDateTime: true,
              appointmentEarlyDateTime: true,
              appointmentState:true,
              appointmentLateDateTime: true,
              estimatedStopDurationUom: true,
              plannedEtaDateTime: true,
              stopActivity: stopActivityProps,
              stopReference: {
                id: true,
                type: true,
                value: true,
                stopId: true,
                shipmentId: true
              }
            },
            shipmentInvolvedParties: {
              id: true,
              partyId: true,
              partyType: true,
              partyName: true,
              partyEmail: true,
              partyPhone: true
            },
            assignmentTransaction: {
              transactionId: true,
              shipmentId: true,
              transactionType: true,
              driverId: true,
              driverPhone: true,
              driverEmail: true,
              status: true,
              driverName: true
            },
            managedEquipment: true,
            automatedTrackingInProgress: true,
          },
          successor: {
            shipmentId: true
          }
        }
      }
    }
  }



  unAssignShipmentToDriver(data: IAssignShipmentToDriverInputProps) {
    return {
      mutation: {
        unassignDriverFromShipment: {
          __args: {
            input: data
          },
          status: true,
          message: true,
          shipment: {
            shipmentId: true,
            carrierPro: true,
            shipmentState: true,
            transportMode: true,
            totalWeight: true,
            weightUOM: true,
            totalDistance: true,
            distanceUOM: true,
            numberOfStops: true,
            sourceTMS: true,
            shipmentTenderedCarriers : {
              recordId : true,
              shipmentId : true,
              carrierId : true,
              offeredRate : true
            },
            division: true,
            assignedCarrierId: true,
            assignedTMSCarrierId: true,
            isHazardous: true,
            isHighValue: true,
            isTemperatureControlled: true,
            readyDateTime: true,
            readyDateTimeZone: true,
            equipmentType: true,
            predecessorShipmentId: true,
            successorShipmentId: true,
            assignmentStatus: true,
            executionStatus: true,
            driverAssignmentStatus: true,
            shipmentServices: {
              serviceDescription: true
            },
            startState: true,
            startCity: true,
            startDateTime: true,
            loadStop: {
              stopId: true,
              locationId: true,
              stopType: true,
              sequenceNo: true,
              locationName: true,
              addressLine1: true,
              addressLine2: true,
              city: true,
              state: true,
              country: true,
              postalCode: true,
              timeZone: true,
              longitude: true,
              latitude: true,
              estimatedArrivalDateTime: true,
              plannedArrivalDateTime: true,
              actualArrivalDateTime: true,
              estimatedStopDuration: true,
              plannedDepartureDateTime: true,
              actualDepartureDateTime: true,
              appointmentEarlyDateTime: true,
              appointmentState:true,
              appointmentLateDateTime: true,
              estimatedStopDurationUom: true,
              plannedEtaDateTime: true,
              stopActivity: stopActivityProps,
              stopReference: {
                id: true,
                type: true,
                value: true,
                stopId: true,
                shipmentId: true
              }
            },
            shipmentInvolvedParties: {
              id: true,
              partyId: true,
              partyType: true,
              partyName: true,
              partyEmail: true,
              partyPhone: true
            },
            shipmentReferences: {
              id: true,
              type: true,
              value: true,
              stopId: true,
              shipmentId: true,
              display: true
            },
            assignmentTransaction: {
              transactionId: true,
              shipmentId: true,
              transactionType: true,
              driverId: true,
              driverPhone: true,
              driverEmail: true,
              status: true,
              driverName: true
            },
            managedEquipment: true
          }
        }
      }
    };
  }

  carrierLoads(_loads: []) {
    return setObject('Carrier-Loads', _loads);
  }
  getCarrierLoads() {
    return getObject('Carrier-Loads');
  }
}
const carrierLoadModal = new CarrierLoads();
Object.freeze(carrierLoadModal);

export default carrierLoadModal;
